import React, { useEffect, useState } from 'react';
import { useP } from '../../i18n/useP';
import { getPayroll } from '../../api/payroll';
import ForecastSocialTab from '../ForecastSocialTab';

/* LE DÉTAIL DES CHARGES SOCIALES SOUS LE PERSONNEL (demande d'Olivier,
   2026-10-03) : la carte de Salaires prévisionnels, calculée sur la même
   table, montée sous les charges de personnel du Résultat prévisionnel. Elle
   y remplace l'onglet « Charges sociales ». */
export default function PayrollSocialCard({ activeTenant, year, unit, reloadKey = 0 }) {
  const p = useP();
  const tid = activeTenant?.id || null;
  const [social, setSocial] = useState(null);
  useEffect(() => {
    if (!tid) return undefined;
    let alive = true;
    getPayroll(tid, year).then((r) => {
      if (alive) setSocial((r && r.data && r.data.social) || null);
    }).catch(() => { if (alive) setSocial(null); });
    return () => { alive = false; };
  }, [tid, year, reloadKey]);
  if (!social || !(social.charges || []).length) return null;
  return (
    <ForecastSocialTab plan={social} hideSalaries title={p('Détail des charges sociales')}
                       activeTenant={activeTenant} year={year} unit={unit} />
  );
}
